export default __webpack_public_path__ + "static/media/rm-history.d4f36ac6.svg";